import { xor } from 'lodash';
import React, { useCallback } from 'react';
import { ButtonToolbar, DropdownButton, MenuItem } from 'react-bootstrap';
import { connect } from 'react-redux';
import { getOrgTermsContent } from '../../content/utils.js';
import { selectReadyProjects } from '../../modules/projects.js';

const mapStateToProps = (state) => ({
  projects: selectReadyProjects(state),
});

ProjectsFilter.defaultProps = {
  selectedProjectsIds: [],
};

function ProjectsFilter({ projects, selectedProjectsIds, navigateAction }) {
  const selectedCount = selectedProjectsIds.length;

  const filteredProjects = projects.filter((project) => !project.archived);

  const handleSelect = useCallback(
    (projectId) =>
      navigateAction({
        projectsIds: projectId ? xor(selectedProjectsIds, [projectId]) : [],
      }),
    [selectedProjectsIds]
  );

  const renderMenuItem = useCallback(
    (project) => (
      <React.Fragment key={project.id}>
        <MenuItem
          active={selectedProjectsIds.includes(project.id)}
          eventKey={project.id}
          onSelect={handleSelect}
        >
          {project.name}
        </MenuItem>
      </React.Fragment>
    ),
    [selectedProjectsIds]
  );

  return (
    <div className="flex-col report-filter">
      <div className="text-muted filter-label">
        {getOrgTermsContent('project')}
      </div>

      <ButtonToolbar>
        <DropdownButton
          bsStyle="info"
          title={selectedCount ? `${selectedCount} Selected` : 'All'}
          id="project-filter"
          className="btn-block"
          onSelect={handleSelect}
          pullRight
        >
          <MenuItem active={selectedCount === 0}>All</MenuItem>
          <MenuItem divider />
          {filteredProjects.map(renderMenuItem)}
        </DropdownButton>
      </ButtonToolbar>
    </div>
  );
}

export default connect(mapStateToProps)(ProjectsFilter);
